import { RiEdit2Line } from "@itandi/itandi-bb-ui";
import Link from "next/link";
import { useCompanyWorkflowSettings } from "~/hooks/useCompanyWorkflowSettings";
import type { WorkflowRequirementType } from "~/models/CompanyWorkflowSetting";
import {
	buildDetailPageButtonLabel,
	WORKFLOW_REQUIREMENT_TYPE
} from "~/models/CompanyWorkflowSetting";
import { PATH as OWNER_BILLINGS_PATH } from "~/pages/deals/[id]/billings/edit";
import { PATH as ESTIMATIONS_EDIT_PATH } from "~/pages/deals/[id]/estimations/edit";
import Styles from "./CompanyWorkflowSettingNavigation.module.scss";

type Props = {
	dealId: number;
	targetScreens: readonly WorkflowRequirementType[];
};

const DETAIL_PAGE_PATH_BUILDER = {
	[WORKFLOW_REQUIREMENT_TYPE.ESTIMATION]: ESTIMATIONS_EDIT_PATH,
	[WORKFLOW_REQUIREMENT_TYPE.OWNER_BILLING]: OWNER_BILLINGS_PATH
} as const satisfies Record<
	WorkflowRequirementType,
	(dealId: number) => string
>;

const buildDetailPagePath = (
	dealId: number,
	targetScreen: WorkflowRequirementType
): string => DETAIL_PAGE_PATH_BUILDER[targetScreen](dealId);

export function CompanyWorkflowSettingNavigation({
	dealId,
	targetScreens
}: Props) {
	const { data: companyWorkflowSettings, isLoading } =
		useCompanyWorkflowSettings();

	if (isLoading || companyWorkflowSettings === null) {
		return null;
	}

	return (
		<>
			{companyWorkflowSettings.map((settingItem) => {
				if (!targetScreens.includes(settingItem.requirementType)) {
					return null;
				}

				return (
					<div className={Styles.NavigationBlock} key={settingItem.id}>
						<div className={Styles.IconWrapper}>
							<RiEdit2Line className={Styles.Icon} />
						</div>
						<div className={Styles.NavigationContent}>
							<div>
								<h4 className={Styles.Title}>{settingItem.title}</h4>
								{settingItem.description !== null && (
									<p className={Styles.Description}>
										{settingItem.description}
									</p>
								)}
							</div>
							<div className={Styles.DetailLinkBlock}>
								<Link
									className={Styles.DetailLink}
									href={buildDetailPagePath(
										dealId,
										settingItem.requirementType
									)}
								>
									{buildDetailPageButtonLabel(settingItem.requirementType)}
								</Link>
							</div>
						</div>
					</div>
				);
			})}
		</>
	);
}
